import { CmsModel, CmsModelEntry } from '@bm-js/atlascloud-shared'
import { TrKey } from '../cnst/translations/trKey.cnst'
import { Tr } from './useTr'

export function getEntryTitle(
  model: CmsModel,
  entry: CmsModelEntry,
  tr: Tr
): string {
  const titleFieldIndex = model.fields.findIndex((f) => f.useAsTitle)
  const modelLabel = model.label
  if (titleFieldIndex === -1) return `${tr(TrKey.new)} ${modelLabel}`

  const titleField = entry.fields[titleFieldIndex]
  if (!titleField.value) return `${tr(TrKey.new)} ${modelLabel}`

  return titleField.value as string
}
